import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input, CheckInput } from "../../../../../common/Input";
import { VesselPickerField } from "../../../../../common/selectComponents/VesselPicker";
import { formatDateTimeForLocalInput } from "../../../../../utils/textUtils";

const FixedLogsConfigAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    dateFrom: "",
    dateTo: "",
    vesselId: "",
    vesselName: "",
    isActive: true,
  });

  const [errors, setErrors] = useState({}); // ADDED: Error state

  useEffect(() => {
    if (selectedItem) {
      setForm({
        ...selectedItem,
        dateFrom: formatDateTimeForLocalInput(selectedItem.dateFrom),
        dateTo: formatDateTimeForLocalInput(selectedItem.dateTo),
      });
    } else {
      setForm({
        dateFrom: "",
        dateTo: "",
        vesselId: "",
        vesselName: "",
        isActive: true,
      });
    }
    setErrors({}); // Reset errors when opening/closing
  }, [selectedItem, isOpen]);

  // ADDED: Real-time validation
  useEffect(() => {
    if (form.dateFrom && form.dateTo) {
      if (new Date(form.dateFrom) > new Date(form.dateTo)) {
        setErrors(prev => ({ ...prev, dateTo: "Date To cannot be earlier than Date From" }));
      } else {
        setErrors(prev => ({ ...prev, dateTo: "" }));
      }
    }
  }, [form.dateFrom, form.dateTo]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10001] bg-black/50 flex items-center justify-center p-3" style={{ marginTop: 0 }}>
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">{selectedItem ? "Edit" : "Add"} Fixed Log</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <VesselPickerField
            label="Vessel"
            vesselId={form.vesselId}
            displayValue={form.vesselName}
            onSelect={(v) => setForm({ ...form, vesselId: v.id, vesselName: v.name })}
            onClear={() => setForm({ ...form, vesselId: "", vesselName: "" })}
            isRequired
          />

          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Date From"
              type="datetime-local"
              value={form.dateFrom}
              onChange={(e) => setForm({ ...form, dateFrom: e.target.value })}
              isRequired
              // MODIFIED: Use validation props from your Input component
              error={!!errors.dateFrom}
              errorMessage={errors.dateFrom}
            />
            <Input
              label="Date To"
              type="datetime-local"
              value={form.dateTo}
              onChange={(e) => setForm({ ...form, dateTo: e.target.value })}
              isRequired
              // MODIFIED: Use validation props from your Input component
              error={!!errors.dateTo}
              errorMessage={errors.dateTo}
            />
          </div>

          <CheckInput
            name="Status (Active/Inactive)"
            value={form.isActive}
            onChange={(val) => setForm({ ...form, isActive: val })}
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button
            onClick={() => onSave(form)}
            // MODIFIED: Disable save if there are errors or missing fields
            disabled={!form.vesselId || !form.dateFrom || !form.dateTo || !!errors.dateTo}
            className="px-6 py-2 bg-blue-600 text-white rounded border-none cursor-pointer disabled:bg-blue-300 disabled:cursor-not-allowed"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default FixedLogsConfigAddEditModal;